/**
 * @generated SignedSource<<0ea9819aab9c2b7db3b07a6a79695e22>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ReferenceRelationEnum = "classmate" | "client" | "coworker" | "friend" | "other";
import { FragmentRefs } from "relay-runtime";
export type ReferenceCard_Reference$data = {
  readonly comments: string | null | undefined;
  readonly name: string | null | undefined;
  readonly otherRelation: string | null | undefined;
  readonly ratingExpert: number | null | undefined;
  readonly ratingOverall: number | null | undefined;
  readonly ratingProfessional: number | null | undefined;
  readonly relation: ReferenceRelationEnum | null | undefined;
  readonly " $fragmentType": "ReferenceCard_Reference";
};
export type ReferenceCard_Reference$key = {
  readonly " $data"?: ReferenceCard_Reference$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReferenceCard_Reference">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReferenceCard_Reference",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "comments",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ratingOverall",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ratingProfessional",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ratingExpert",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "relation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "otherRelation",
      "storageKey": null
    }
  ],
  "type": "Reference",
  "abstractKey": null
};

(node as any).hash = "1b8a63f7ab8c90f288a16d6758c15650";

export default node;
